import styled from "styled-components";

export const Overlay = styled.div`
  position: fixed;
  z-index: 1300;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(33, 41, 52, 0.32);
  display: flex;
  align-items: center;
  justify-content: center;
  
  /* Ensure Ant Design tooltips appear above modal */
  .ant-tooltip {
    z-index: 1500 !important;
  }
  
  .ant-tooltip-inner {
    z-index: 1500 !important;
  }
`;

export const Modal = styled.div`
  background: #fff;
  border-radius: 12px;
  width: 800px;
  max-width: 95vw;
  max-height: 90vh;
  box-shadow: 0 8px 32px rgba(33, 41, 52, 0.16);
  padding: 24px;
  position: relative;
  font-family: "Manrope", sans-serif;
  z-index: 1400;
  display: flex;
  flex-direction: column;
  overflow: visible;
`;

export const CloseButton = styled.div`
  position: absolute !important;
  right: 24px;
  top: 24px;
  background: none;
  border: none;
  font-size: 20px;
  color: #aeb8c4;
  cursor: pointer;
  border-radius: 4px !important;
  &:hover {
    background-color: #f3f4f7;
  }
`;

export const ModalTitle = styled.div`
  font-family: "Manrope", sans-serif;
  font-weight: 600;
  font-size: 20px;
  line-height: 30px;
  color: #1b2028;
  margin-bottom: 8px;
  padding-right: 40px;
`;

export const MergeInstructionText = styled.div`
  font-family: "Manrope", sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #5A6C87;
  margin-bottom: 16px;
  padding-right: 40px;
`;

export const SearchSection = styled.div`
  margin-bottom: 16px;
`;

export const BreadcrumbSection = styled.div`
  margin-bottom: 16px;
  position: relative;
  z-index: 1;
`;

export const TreeSection = styled.div`
  flex: 1;
  overflow-y: auto;
  min-height: 300px;
  max-height: 400px;
  margin-bottom: 24px;
  border: 1px solid #f3f4f7;
  border-radius: 8px;
  padding: 16px;
`;

export const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding-top: 16px;
  border-top: 1px solid #f3f4f7;
`;

export const CancelButton = styled.button`
  font-family: "Manrope", sans-serif;
  font-weight: 600;
  font-size: 13px;
  line-height: 100%;
  letter-spacing: 0;
  border-radius: 6px;
  border: 1px solid #dde2e9;
  background: #f3f4f7;
  color: #1b2028;
  padding: 10px 12px;
  min-width: 68px;
  height: 32px;
  cursor: pointer;
  transition: background 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    background-color: #e3e6e8;
  }
`;

export const ProceedButton = styled.button`
  font-family: "Manrope", sans-serif;
  font-weight: 600;
  font-size: 13px;
  line-height: 100%;
  letter-spacing: 0;
  border-radius: 6px;
  border: none;
  background: #0c53bb;
  color: #fff;
  padding: 10px 12px;
  min-width: 68px;
  height: 32px;
  cursor: pointer;
  transition: background 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: ${(props) => (props.disabled ? 0.4 : 1)};
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  &:hover {
    background: ${(props) => (props.disabled ? "#0c53bb" : "#084080")};
  }
`;

export const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const ListItem = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 12px;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.2s;
  background-color: ${(props) => (props.isSelected ? "#F1F6FE" : "transparent")};
  
  &:hover {
    background-color: ${(props) => (props.isSelected ? "#F1F6FE" : "#F3F4F7")};
  }
`;

export const ListItemContent = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
`;

export const ListItemIcon = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
`;

export const ListItemName = styled.div`
  font-family: "Manrope", sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #48566B;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
  display:flex;
`;

export const EmptyState = styled.div`
  font-family: "Manrope", sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: #5A6C87;
  text-align: center;
  padding: 40px 20px;
`;
export const AngularExpandIcon = styled.div`
margin-left: 10px;
`